// extracted by mini-css-extract-plugin
export default {"icon":"IsBusinessDay_icon__3xdL1"};